/* eslint-disable @typescript-eslint/no-unused-vars */
import { forwardRef } from 'react';
import noop from 'utils/noop';
import styled from 'styled-components';
import { BUTTON_VARIANTS, BUTTON_SIZES } from 'ui/button/constants';
import { Button, ButtonProps } from 'ui/button';
import { OpenNewWindow16 } from 'ui/icons';

interface EditContentButtonProps extends ButtonProps {
  /** Callback when the button is clicked */
  onClick?: (e: any) => void;
  /** The size of the icon */
  iconSize?: number;
  /** Any additional props to pass to the icon */
  iconProps?: any;
  /** Is the button disabled? */
  isDisabled?: ButtonProps['isDisabled'];
}

const StyledOpenNewWindow16 = styled(OpenNewWindow16)`
   {
    margin-left: 10px;
  }
`;

export const EditContentButton = forwardRef<HTMLButtonElement>(function EditContentButton(
  { onClick = noop, isDisabled = false, children, iconProps, ...props }: EditContentButtonProps,
  ref,
) {
  const handleClick = (e: React.MouseEvent) => {
    if (isDisabled) return;
    onClick(e);
  };

  return (
    <Button
      variant={BUTTON_VARIANTS.SECONDARY}
      size={BUTTON_SIZES.SMALL}
      onClick={handleClick}
      isDisabled={isDisabled}
      ref={ref}
      {...props}
    >
      Edit content <StyledOpenNewWindow16 />
    </Button>
  );
});
